/*
 * @Author: huangzq
 * @Date: 2019-10-11 15:28:47
 * @Last Modified by: huangzq
 * @Last Modified time: 2019-10-11 15:29:32
 * @Desc: 将地址参数转为对象
 */
export default (query = window.location.search.substr(1)) => {
  if (query.startsWith('?')){
    query = query.substring(1);
  }
  const reg = /([^=&\s]+)[=\s]*([^&\s]*)/g;
  const obj: any = {};
  while (reg.exec(query)) obj[RegExp.$1] = RegExp.$2;
  return obj;
};

/** 替换 url(hash模式) 对应的 query 参数, 找不到则新增 入餐是一个对象 */
export const modifyQueryParams = (obj: Record<string, string>) => {
  const currentHash = window.location.hash;
  const hashObj = currentHash.split('?');
  const length = hashObj.length;
  const newParams = new URLSearchParams(hashObj[length - 1]); // 取 ? 后面的字符串

  // 遍历待修改的对象
  for (const key in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      newParams.set(key, value);
    }
  }
  const path = length > 1 ? hashObj[0] : '';
  const newHash = `${path}?${newParams.toString()}`;

  // url 解码
  const url = `${location.origin}${location.pathname}${decodeURIComponent(newHash)}`;

  return url;
};
